import { useState, useEffect } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import MdfMural from "./MdfMural";
import WoodMural from "./WoodMural";
import { styled } from "@mui/system";
import { useLocation, useNavigate } from "react-router-dom";

// Styled components
const CustomTabs = styled(Tabs)({
  minHeight: "42px",
  backgroundColor: "#f7f3ec",
  borderBottom: "1px solid rgba(184, 145, 88, 0.22)",
  padding: "0 22px",
  "& .MuiTabs-indicator": {
    backgroundColor: "#a8563c",
    height: "1px",
  },
});

const CustomTab = styled(Tab)({
  textTransform: "none",
  minHeight: "42px",
  fontWeight: 500,
  fontSize: "0.86rem",
  color: "rgba(30, 27, 22, 0.68)",
  padding: "0 16px",
  transition: "color 160ms ease",
  "&.Mui-selected": {
    color: "#1e1b16",
  },
  "&:hover": {
    color: "#a8563c",
  },
});

export default function MuralTabs() {
  const [value, setValue] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  // Update tab based on query param
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get("tab");
    if (tabParam === "wood") {
      setValue(1);
    } else {
      setValue(0);  // Default is MDF
    }
  }, [location.search]);

  // When tab changes, update the URL
  const handleChange = (event, newValue) => {
    setValue(newValue);
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("tab", newValue === 1 ? "wood" : "mdf");
    navigate(`${location.pathname}?${queryParams.toString()}`);
  };

  return (
    <Box sx={{ width: "100%", backgroundColor: "#f7f3ec" }}>
      <CustomTabs value={value} onChange={handleChange}>
        <CustomTab label="MDF Murals" />
        <CustomTab label="Wood Murals" />
      </CustomTabs>

      <Box>
        {value === 0 && <MdfMural />}
        {value === 1 && <WoodMural />}
      </Box>
    </Box>
  );
}
